<div class="ol-control">
    <div class="dropup">
        <button class="overlay-legend-btn" data-toggle="dropdown" type="button" title="Legend"
            [ngClass]="{ 'bg-primary': legendExpanded }" (click)="legendExpanded = !legendExpanded">
            <i class="icon-dotlist"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right p-0" [ngClass]="{ show: legendExpanded }">
            <div *ngFor="let layer of layers" [hidden]="!HsLegendService.legendValid(layer)">
                <p class="text-light bg-secondary" style="padding: 0.5em 0.75em">
                    {{ HsLanguageService.getTranslationIgnoreNonExisting("LAYERS", layer.title ) }}
                </p>
                <hs-legend-layer-directive class="d-block p-1" [layer]="layer"></hs-legend-layer-directive>
            </div>
        </div>
    </div>
</div>